module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.$root.dataReady) ? _c('div', {
    staticClass: "case"
  }, [_c('header', {
    staticClass: "page-heading"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "text",
    domProps: {
      "innerHTML": _vm._s(_vm.post.content.rendered)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "hero-caption"
  }, [_c('em', [_vm._v(_vm._s(_vm.hero_caption))])])])]), _vm._v(" "), _c('div', {
    staticClass: "main-content"
  }, [
    [_vm._l((_vm.blocks), function(block, index) {
      return [_c(block.acf_fc_layout, {
        key: index,
        tag: "component",
        attrs: {
          "blockdata": block,
          "slug": _vm.slug,
          "post_id": _vm.post_id
        }
      })]
    })], _vm._v(" "), _c('div', {
      staticClass: "bottom-button"
    }, [_c('router-link', {
      staticClass: "btn default",
      attrs: {
        "tag": "a",
        "to": {
          path: '/' + _vm.slug
        }
      },
      domProps: {
        "innerHTML": _vm._s(_vm.button)
      }
    })], 1)
  ], 2)]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c0e0dcfc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Case.vue
// module id = 366
// module chunks = 0